import React, { useEffect } from "react";

import "./App.css";
import { Route, Routes } from "react-router-dom";
// import Header from "./components/header/Header";
import allProductRoutes from "./components/routes/product";
import mainDashboardRoutes from "./components/routes/managementDashboard";
import allItemRoutes from "./components/routes/item";
import allProductionRoutes from "./components/routes/productionDashboard";
import authenticationRoutes from "./components/routes/authentication";
import Admin from "./Admin";
import Create from "./components/admin/Create.js";
import Edit from "./components/admin/Edit.js";
import Delete from "./components/admin/Delete.js";

import Department from "./components/department/DepartmentSelect";
import Landing from "./components/landing/landing";
import Sidebar from "./components/dashboard/main/MainLayout";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Header from "./components/header/header";
import WarehouseDashboard from "./components/warehouse/WarehouseDashboard";
import ManagementDashboard from "./components/dashboard/management/ManagementDashboard";
import productionDashboardRoutes from "./components/routes/productionDashboard";
import warehouseDashboardRoutes from "./components/routes/warehouseDashboard";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "./components/redux/slices/user/userSlice";
//import { ConnectedRouter } from "connected-react-router";
import { history } from "./components/redux/ConfigureStore";
import SubscriptionDetail from "./components/auth/SubscriptionDetail";
import CompanyDetails from "./components/auth/CompanyDetails";
import AccountRegistration from "./components/auth/AccountRegistration";
import Button from "./components/ui/Button";
import AppBar from "./components/appbar/AppBar";
import Tour from "./components/landingpage/tour/Tour";
import Pricing from "./components/landingpage/Pricing";
import managementDashboard from "./components/routes/managementDashboard";
import { getAuthorization } from "./components/axios/AxiosAut";

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },

      toolbar: theme.mixins.toolbar,
    },
  })
);




export default function App() {
  const productionRoutes = allProductionRoutes();
  const productRoutes = allProductRoutes();
  const itemRoutes = allItemRoutes();
  const managementDashboard = mainDashboardRoutes();
  const productionDashboard = productionDashboardRoutes();
  const warehouseDashboard = warehouseDashboardRoutes();
  const user = useSelector((state) => state.user);



  return (
    <>
      {/* <Pricing /> */}
      {/* <Button text="login" type="button" onClick={() => {}} /> */}
      {/* <SubscriptionDetail HandleNext={() => {}}  ></SubscriptionDetail> tere is change */}
      <Routes>
        {authenticationRoutes}
        {managementDashboard}
        {productionDashboard}
        {warehouseDashboard}
        {user.email && (
          <>
            {/* {productionRoutes} */}
            {productRoutes}
            {itemRoutes}
            <Route path="/department" element={<Department />} />
            {/* <Route
                    
                    path="/department/warehouse-dashboard"
                    render={(props) => (
                      <WarehouseDashboard title="warehouse" {...props} />
                    )}
                  />
                  <Route
                    
                    path="/department/management-dashboard"
                    render={(props) => (
                      <ManagementDashboard title="management" {...props} />
                    )}
                  /> */}
          </>
        )}
      </Routes>
    </>
  );
}
